import t from "@/lang/lang";
import { Button } from "@/shared/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import { CommonDialogFooter } from "@/shared/components/dialog/dialog-common";
import { Trash2 } from "lucide-react";
import { useEffect, useState } from "react";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useTextblocksTextblockDeleteMutation } from "@/services/backend/textblocks/api/textblock-api";
import { Textblock } from "@/services/backend/textblocks/types/textblock";

export function DeleteTextblocksDialog({
  selected,
}: {
  selected: Textblock[];
}) {
  const [open, setOpen] = useState(false);
  const [del, { isLoading, error, isSuccess, reset }] =
    useTextblocksTextblockDeleteMutation();

  const disabled = selected.some((tb) => tb.immutable);
  const count = selected.length;

  useEffect(() => {
    if (isSuccess) {
      setOpen(false);
      reset();
    }
  }, [isSuccess, reset]);

  const doDelete = () => {
    if (isLoading || disabled) return;

    del({ ids: selected.map((textblock) => textblock.id) });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button
          variant="destructive"
          disabled={disabled || selected.length === 0}
          size="sm"
        >
          <Trash2 />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("Bemerkungen löschen")}</DialogTitle>
          <DialogDescription>
            {t(`Möchten Sie ${count} ausgewählte Bemerkung(en) löschen?`)}
          </DialogDescription>
        </DialogHeader>
        <RTKQueryErrorAlert error={error} ignoreValidationError={false} />
        <CommonDialogFooter
          isLoading={false}
          onClickAction={doDelete}
          destructive
        />
      </DialogContent>
    </Dialog>
  );
}
